import {
    useCallback, useReducer,
} from 'react';

type State = Record<string, unknown>;
type Action = { type: 'setData'; payload: State };

const initialState: State = {

};

const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'setData':
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export const useAdvisoryDocument = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const setData = useCallback((lData: State) => {
        dispatch({ type: 'setData', payload: lData });
    }, []);

    return {
        data: state,
        setData,
    };
};
